import useSWR from "swr";
import { z } from "zod";
import { Network } from "@/utils/network";
import { zodUnsafeValidate } from "@/utils/zod";
import { InstagramSearch } from "../types";
import { useInstagramSearch } from "./useInstagramSearch";

const InstagramSearchCategoriesResponseSchema = z.object({
  categories: InstagramSearch.OptionSchema.array(),
});

type InstagramSearchCategoriesResponse = z.infer<
  typeof InstagramSearchCategoriesResponseSchema
>;

export const useInstagramSearchCategories = (query: string) => {
  const config = useInstagramSearch((state) => state.config);

  return useSWR(
    [config.api.getCategories, query],
    async ([api, query]) => {
      const { data } = await Network.get<InstagramSearchCategoriesResponse>(
        api,
        {
          query,
        },
      );

      return zodUnsafeValidate(InstagramSearchCategoriesResponseSchema, data);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
      revalidateOnReconnect: true,
      shouldRetryOnError: false,
      keepPreviousData: true,
    },
  );
};
